<template>
    <div class="manage-upload">
        <div class="upload-file">
            <h3>{{$t('manage.UploadFiles')}}</h3>
            <div class="hint">{{$t('manage.acceptFile')}}</div>
            <ul>
                <li v-for="(item, index) in uploadList" :key="index" class="file-moudle">
                    <div class="file-title">{{item.title}}</div>
                    <div class="input-module">
                        <div
                            class="file-hint"
                            v-if="!uploadList[index].filename"
                        >{{$t('manage.UploadFile')}}</div>
                        <div class="file-uploaded" v-if="uploadList[index].filename">
                            <i class="delete" @click="handleRemove(uploadList[index])"></i>
                            <img :src="item.file" :alt="item.title" v-if="item.file_type == 'IMG'" />
                            <img :src="defaultFileImg" :alt="item.title" v-else />
                            <span class="file-filename">{{item.filename}}</span>
                            <!-- <el-progress :text-inside="true" :stroke-width="26" :percentage="70"></el-progress> -->
                        </div>
                        <input
                            type="file"
                            accept="image/gif, image/jpeg, image/png, application/pdf"
                            :files="fileList[index]"
                            :name="preProcessName(item.title)"
                            v-on:input="onFileChange($event, item)"
                        />
                    </div>
                </li>
            </ul>
            <p class="upload-promise">{{$t('manage.uploadPrivacy')}}</p>
            <el-button
                type="primary"
                class="upload-btn"
                @click="onSubmit"
            >{{$t('manage.UpdateandComplete')}}</el-button>
        </div>
    </div>
</template>
<script>
import { Message } from "element-ui";
import { Loading } from "element-ui";

let loading;
export default {
    name: "manageUpload",
    props: ["selectProp", "uploadList", "requestParams", "requestHeaders"],
    data() {
        const $t = this.$t.bind(this);
        let defaultFileImg = require("../../../../website_20/static/img/manage/icon-pdf.svg");
        return {
            details_html: "",
            eventId: 0,
            fileList: [],
            defaultFileImg: defaultFileImg
        };
    },

    methods: {
        onFileChange(e, item) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            let imageUrl;
            let reader = new FileReader();
            let self = this;
            reader.readAsDataURL(files[0]);
            reader.onload = function(event) {
                imageUrl = event.target.result;
                self.uploadToServer(files[0], imageUrl, item);
            };
            // reader.onprogress = function(event) {
            //     if (event.lengthComputable) {
            //         var percentage = Math.round(
            //             (event.loaded * 100) / event.total
            //         );
            //     }
            // };
        },

        uploadToServer(file, imageUrl, item) {
            // param structure
            let params = {
                id: item.id,
                filename: this.preProcessName(
                    `${item.title}.${file.type.split("/", -1)[1]}`
                ),
                file: imageUrl
            };

            let fileUrl = `${this.requestParams.ppbApi}api/passbook/document/${item.event}/${item.id}`;
            this.loading();
            this.$http
                .patch(fileUrl, params, this.requestHeaders)
                .then(resp => {
                    if (resp.data.status != "ok") {
                        this.triggerMessage("error", {
                            message: "Upload failed!"
                        });
                    } else {
                        loading.close();
                        this.uploadList.filter(it => {
                            if (it.id == item.id) {
                                it.file = imageUrl;
                                it.filename = params.filename;
                                it.file_type =
                                    file.type.split("/", 1).join("") == "image"
                                        ? "IMG"
                                        : "FILE";
                            }
                        });
                    }
                });
        },

        preProcessName(title) {
            let name = title
                .toLowerCase()
                .split("& ", -1)
                .join("")
                .replace(/ /g, "-");
            return name;
        },

        handleRemove(file) {
            let fileUrl = `${this.requestParams.ppbApi}api/passbook/document/${file.event}/${file.id}`;
            this.loading();
            this.$http.delete(fileUrl, this.requestHeaders).then(resp => {
                if (resp.data.status != "ok") {
                    this.triggerMessage("error", {
                        message: "Delete failed!"
                    });
                } else {
                    loading.close();
                    this.triggerMessage("success", {
                        message: this.$t("manage.deleteFile_s")
                    });
                    this.uploadList.filter(it => {
                        if (it.id == file.id) {
                            it.file = null;
                            it.filename = null;
                        }
                    });
                }
            });
        },

        onSubmit() {
            let checkAllFile = this.uploadList.every(it => {
                return it.filename && it.file;
            });

            if (!checkAllFile) {
                return;
            }

            let changeStatusUrl = `${this.requestParams.ppbApi}api/passbook/event/${this.eventId}`;
            let params = {
                id: this.eventId,
                status: "PENDING"
            };
            this.loading();
            this.$http
                .put(changeStatusUrl, params, this.requestHeaders)
                .then(resp => {
                    loading.close();
                    this.$emit("changeView", "detail");
                });
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".manageContainer",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        goToPage() {
            this.$emit("changeView", "detail");
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    watch: {
        eventObj: {
            handler(newVal, oldVal) {
                this.$http
                    .get(newVal.details, "text/html, text/plain")
                    .then(resp => {
                        // this.details_html = resp.data;
                    });
            }
        },

        uploadList: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.eventId = newVal[0].event;
                }
            }
        }
    }
};
</script>
<style lang="scss">
.manage-upload {
    .goToProp {
        font-family: GothamBook;
        font-size: 14px;
        color: var(--windows-blue);
        &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 12px;
            margin-right: 9px;
            background: url("../../../../website_20/static/img/icon-arrow-l-blue.svg")
                no-repeat;
            background-size: contain;
        }
    }

    .nav-link {
        margin-bottom: 30px;
    }

    .upload-file {
        // margin-top: 30px;
        // box-shadow: 0 5px 10px -10px rgba(0, 0, 0, 0.2);
        // border: solid 1px #eaf0f7;
        // border-top: 8px solid #3b6bbf;
        // background-color: #fbfcff;
        // border-top-left-radius: 8px;
        // border-top-right-radius: 8px;
        padding: 20px 20px 30px;
        h3 {
            font-family: GothamBook;
            font-size: 22px;
            line-height: 1.45;
            color: #2e384d;
        }
        .hint {
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1;
            margin-top: 5px;
            margin-bottom: 20px;
            letter-spacing: 0.46px;
            color: #333333;
        }
        .file-moudle {
            padding-bottom: 16px;
            border-bottom: 1px solid #e7effc;
            margin-bottom: 20px;
            .file-title {
                font-family: GothamBook;
                font-size: 14px;
                line-height: 1;
                letter-spacing: 0.46px;
                color: #333333;
                margin-bottom: 16px;
            }
            .file-area {
                position: relative;
                .el-upload-list {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    .el-upload-list__item {
                        margin: 0;
                        width: 100%;
                        height: 70px;
                        padding-top: 0;
                        padding-bottom: 0;
                        border: 0;
                        border-radius: 0;
                        .el-upload-list__item-thumbnail {
                            width: 44px;
                            height: 44px;
                            object-fit: contain;
                            margin-top: 10px;
                        }
                        .el-upload-list__item-name {
                            font-family: GothamMedium;
                            font-size: 13px;
                            font-weight: 500;
                            color: #4c4c4c;
                            i {
                                font-size: 44px;
                            }
                        }
                    }
                }
                .el-upload {
                    width: 100%;
                }
                input.el-upload__input {
                    display: none;
                }
            }
            .input-module {
                position: relative;
                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    opacity: 0;
                    height: 44px;
                }
            }
            .file-hint {
                cursor: pointer;
                width: 100%;
                height: 44px;
                line-height: 44px;
                border-radius: 4px;
                border: dashed 1.5px var(--windows-blue);
                text-align: center;
                padding: 0;
                font-family: GothamMedium;
                font-size: 14px;
                font-weight: 500;
                text-align: center;
                color: var(--windows-blue);
            }
            .file-uploaded {
                position: relative;
                width: 100%;
                padding: 9px 0 0;
                .delete {
                    display: inline-block;
                    position: absolute;
                    right: 0;
                    top: 20px;
                    cursor: pointer;
                    width: 18px;
                    height: 20px;
                    z-index: 12;
                    background: url("../../../../website_20/static/img/manage/icon-bin.svg")
                        no-repeat;
                    background-size: contain;
                }
                img {
                    width: 44px;
                    height: 44px;
                    object-fit: contain;
                    margin-right: 20px;
                }
                .file-filename {
                    font-family: GothamMedium;
                    font-size: 13px;
                    margin-top: 13px;
                    line-height: 1.23;
                    color: #4c4c4c;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 220px;
                    display: inline-block;
                }
            }
        }
        .upload-promise {
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1.2;
            color: var(--windows-blue);
        }
        .upload-btn {
            height: 40px;
            width: 100%;
            border-radius: 4px;
            background-color: var(--windows-blue);
            font-family: GothamMedium;
            font-size: 14px;
            font-weight: 500;
            color: var(--white);
            margin-top: 20px;
            border-color: transparent;
            padding-top: 0;
            padding-bottom: 0;
            span:before {
                content: "";
                display: inline-block;
                margin-right: 10px;
                width: 13px;
                height: 15px;
                margin-bottom: -3px;
                background: url("../../../../website_20/static/img/manage/icon-attachment-white.svg")
                    no-repeat;
                background-size: contain;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/manageUpload.vue